// extracted by mini-css-extract-plugin
module.exports = {"container":"_d0fbdf7","icon":"_c49cd0a","text":"_c96b404"};